import React from "react";
import { SxStyleProp } from "theme-ui";
import inputStyles from "../../styles/input";
import Flex from "../Flex/Flex";
import Box, { Props as BoxProps } from "../Box/Box";
import { DownArrowIcon } from "../icons";

interface Props
  extends React.HTMLAttributes<HTMLSelectElement & HTMLDivElement> {
  sx?: SxStyleProp;
  outerSx?: SxStyleProp;
}

const Select: React.FunctionComponent<Props | BoxProps> = React.forwardRef(
  ({ sx, outerSx, ...restProps }, ref) => (
    <Flex
      sx={{
        ...(outerSx as any),
      }}
    >
      <Box
        ref={ref}
        as="select"
        variant="select"
        data-testid="select"
        sx={{
          ...inputStyles.base,
          ...(sx as any),
        }}
        {...restProps}
      />
      <DownArrowIcon
        sx={{
          ml: -28,
          alignSelf: "center",
          pointerEvents: "none",
          fill: "muted",
        }}
      />
    </Flex>
  ),
);

Select.displayName = "Select";

export default Select;
